const partners = [
  {
    name: "Ubitus",
    href: "https://ubitus.net/",
    logo: "https://up.abstractdata.ai/uploads/2025/08/UBitusLogo-1.png",
  },
  {
    name: "ASUS",
    href: "https://www.asus.com/",
    logo: "https://up.abstractdata.ai/uploads/2025/12/asus-1.png",
  },
  {
    name: "DELL",
    href: "https://www.dell.com/",
    logo: "https://up.abstractdata.ai/uploads/2025/12/Dell.jpeg",
  },
  {
    name: "Gigabyte",
    href: "https://www.gigabyte.com/",
    logo: "https://up.abstractdata.ai/uploads/2025/12/gigabyte.png",
  },
  {
    name: "Supermicro",
    href: "https://www.supermicro.com/",
    logo: "https://up.abstractdata.ai/uploads/2025/12/supermicro-1.png",
  },
];

export default function PartnersSection() {
  return (
    <section className="px-4 md:px-6 py-16 md:py-20 bg-background-100 border-y border-background-200">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-center font-heading font-bold text-3xl md:text-4xl text-foreground-950 mb-12">
          Partners
        </h2>
        <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10">
          {partners.map((p) => (
            <a
              key={p.name}
              href={p.href}
              target="_blank"
              rel="nofollow noreferrer"
              className="shrink-0 flex items-center justify-center w-[140px] md:w-[160px] h-[64px] rounded-lg bg-background-50 border border-background-200 hover:border-foreground-300 transition-colors cursor-pointer overflow-hidden"
            >
              <img
                src={p.logo}
                alt={`${p.name} logo`}
                title={`${p.name} partner`}
                className="max-h-[44px] max-w-[120px] w-auto h-auto object-contain"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}